"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSLOverrideEventType = exports.MSLOverrideEventSource = void 0;
var MSLOverrideEventSource;
(function (MSLOverrideEventSource) {
    MSLOverrideEventSource["LrMstrCust"] = "lr_mstr_cust";
    MSLOverrideEventSource["LrMstrOverride"] = "lr_mstr_override";
    MSLOverrideEventSource["LrMstrOverrideCust"] = "lr_mstr_override_cust";
    MSLOverrideEventSource["LrMstrOverrideDetail"] = "lr_mstr_override_detail";
})(MSLOverrideEventSource = exports.MSLOverrideEventSource || (exports.MSLOverrideEventSource = {}));
var MSLOverrideEventType;
(function (MSLOverrideEventType) {
    MSLOverrideEventType["MSLOverrideEvent"] = "MSLOverrideEvent";
    MSLOverrideEventType["MSLCustomerEvent"] = "MSLCustomerEvent";
})(MSLOverrideEventType = exports.MSLOverrideEventType || (exports.MSLOverrideEventType = {}));
